"use client"

import {
  addArticleToCurrentBasketAction,
  determineCrossSellingProductsAction,
  fetchExtendedPricesAction,
  fetchProductAction,
} from "@/actions/basketActions"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { ProductPriceContainerCtnrROV1 } from "@ub/pricing-client"
import { ShoppingCart } from "lucide-react"

import { logger } from "@/lib/logger"
import { LegacyProductPriceContainer } from "@/lib/storefront/product/legacy-price-service"
import { ReducedProductData } from "@/lib/storefront/product/product"
import { trackAddToBasket, trackFFProductClick } from "@/lib/tracking/tracking-helper"
import { Button } from "@/components/ui/components"

export default function AddToBasketButtonClient(props: {
  isoLocale: string
  isB2BCustomer: boolean
  articleIdToAdd: string
  productData: ReducedProductData | undefined
  prices: ProductPriceContainerCtnrROV1 | undefined
  quantity: number
  label?: string
  className?: string
  showSmall?: boolean
  position?: number
  trackingList?: string
  searchTerm?: string | undefined
  simulateProductClick: boolean
  text?: string
}) {
  const {
    setAddToBasketDialogVisible,
    setProductDataAddedToBasket,
    setBasketData,
    setCrosssellingProductDataAddedToBasket,
    setProductDataAddedToBasketPrices,
    setIsLoading,
  } = useUbStorefrontState()
  // const t = useTranslations("storefront")

  async function addToBasket() {
    if (props.articleIdToAdd) {
      addArticleToCurrentBasketAction(props.articleIdToAdd, props.quantity)
        .then((res) => {
          // console.log(`ProductCardAddToBasket: props.quantity=${props.quantity}`)
          // console.log(`ProductCardAddToBasket: setBasketData()`)
          // console.dir(newBasketData)
          setBasketData(res.basketData)
          trackAddToBasket(res.isoLocale, res.isB2B, res.product, props.prices, props.quantity)
          if (props.simulateProductClick) {
            trackFFProductClick(res.product, "direct", 1, "")
          }
        })
        .catch((reason) => {
          logger.error(`ProductCardAddToBasket: Backend problem: ${reason}`)
        })

      const crosssellingProducts = await determineCrossSellingProductsAction(props.articleIdToAdd)
      setCrosssellingProductDataAddedToBasket(crosssellingProducts)
    }
  }

  function addToBasketAndShowDialog() {
    setIsLoading(true)
    addToBasket()
      .then(() => {
        // console.log(`ProductCardAddToBasket: setProductDataAddedToBasket`)
        // console.dir(props.productData)
        if (props.productData) {
          setProductDataAddedToBasket(props.productData)
        } else {
          fetchProductAction(props.articleIdToAdd).then((product: ReducedProductData | undefined) => {
            setProductDataAddedToBasket(product)
          })
        }
        // console.log(`ProductCardAddToBasket: setProductDataAddedToBasketPrices`)
        // console.dir(props.prices)
        if (props.prices) {
          setProductDataAddedToBasketPrices(props.prices)
        } else {
          fetchExtendedPricesAction(props.articleIdToAdd).then((prices: LegacyProductPriceContainer | undefined) => {
            setProductDataAddedToBasketPrices(prices?.productPriceContainer)
          })
        }
      })
      .finally(() => {
        setAddToBasketDialogVisible(true)
        setIsLoading(false)
      })
  }

  return (
    <Button
      className={props.className}
      aria-label={props.label}
      size={props.showSmall ? "productCardIconSmall" : "productCardIcon"}
      onClick={(e) => {
        e.preventDefault()
        addToBasketAndShowDialog()
      }}
    >
      {props.label}
      <div className={"flex flex-row items-center justify-between gap-2"}>
        <ShoppingCart className={"size-4"} />
        {props.text && <p className={"text-xs"}>{props.text}</p>}
      </div>
    </Button>
  )
}
